module.exports = __webpack_public_path__ + "static/teamsable-bfd551d5e039785625e472ab0047727d.png";